import React from 'react'
import { l } from '@manychat/manyui'

import { EmptyNode } from 'common/builder/components/chart/FlowChart/components/EmptyNode/EmptyNode'
import { NextStep } from 'common/builder/components/chart/FlowChart/components/NextStep/NextStep'
import { NodeContainer } from 'common/builder/components/chart/FlowChart/components/Node/components/NodeContainer/NodeContainer'
import { NodeContentWrapper } from 'common/builder/components/chart/FlowChart/components/Node/components/NodeContentWrapper/NodeContentWrapper'
import { NodeHeader } from 'common/builder/components/chart/FlowChart/components/Node/components/NodeHeader/NodeHeader'
import { ConditionGroup } from 'common/builder/components/chart/FlowChart/components/Node/Condition/ConditionGroup'
import { NodeComponent } from 'common/builder/components/chart/FlowChart/components/Node/types'
import { NODE_PLACEHOLDER_ID } from 'common/builder/components/chart/FlowChart/constants'
import { useFlowChartState } from 'common/builder/components/chart/FlowChart/contexts/FlowChartStateContext'
import { ConditionConfig } from 'common/builder/components/chart/FlowChart/nodes/shared/config'
import { FlowChartConditionNode } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartConditionNode'

import * as styles from './Condition.styles'

export const ConditionNode: NodeComponent<FlowChartConditionNode> = ({
  container,
  node: {
    id: nodeId,
    data: { header, conditionGroups, nextStep },
  },
  builderId,
}) => {
  const { isNoInteractions } = useFlowChartState()

  const isEmpty = conditionGroups.length === 0

  return (
    <NodeContainer
      container={container}
      nodeId={nodeId}
      builderId={builderId}
      disableFlowChartInteractions={isNoInteractions}
      width={ConditionConfig.width}
      highlightColor={ConditionConfig.highlightColor}
    >
      <NodeHeader header={header} />
      <NodeContentWrapper>
        {!isEmpty &&
          conditionGroups.map((conditionGroup, index) => (
            <ConditionGroup
              conditionGroup={conditionGroup}
              key={conditionGroup.nextStep.id}
              isLast={index === conditionGroups.length - 1}
            />
          ))}
        {isEmpty && (
          <EmptyNode
            id={NODE_PLACEHOLDER_ID}
            text={l.getString(ConditionConfig.placeholderText)}
            hoverBackground={ConditionConfig.placeholderBackground}
            hoverBorderColor={ConditionConfig.placeholderBorderColor}
          />
        )}
      </NodeContentWrapper>
      {nextStep ? <NextStep nextStep={nextStep} /> : <view style={styles.NextStepSpacer} />}
    </NodeContainer>
  )
}
